var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isOpenSvg()),expression:"!isOpenSvg()"}]},[_vm._l((_vm.primitivesList),function(item){return [_c(item.component,{key:item.registerName,tag:"component",attrs:{"primitives":item.primitives,"fvSystemApi":item.fvSystemApi,"parentObject":item.parentObject}})]})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c290ff98","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/system/fvGroupObj.vue
// module id = null
// module chunks = 